import React from 'react';
import PracticeCard from './PracticeCard';
import Icon from '../../../components/AppIcon';

const PracticeGrid = ({ 
  practices, 
  selectedPractices, 
  onSelectPractice, 
  onViewDetails,
  isLoading = false 
}) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {[...Array(6)]?.map((_, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-6 animate-pulse">
            <div className="flex items-start justify-between mb-4">
              <div className="flex-1">
                <div className="flex items-center space-x-3 mb-2">
                  <div className="bg-muted h-6 w-12 rounded"></div>
                  <div className="bg-muted h-5 w-16 rounded-full"></div>
                </div>
                <div className="bg-muted h-6 w-3/4 rounded mb-2"></div>
                <div className="bg-muted h-4 w-full rounded"></div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div className="bg-muted h-4 w-full rounded"></div>
              <div className="bg-muted h-4 w-full rounded"></div>
            </div>
            <div className="flex justify-between pt-4 border-t border-border">
              <div className="bg-muted h-8 w-24 rounded"></div>
              <div className="bg-muted h-8 w-32 rounded"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (practices?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name="Search" size={48} className="text-muted-foreground mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-foreground mb-2">No Practices Found</h3>
        <p className="text-muted-foreground max-w-md mx-auto">
          No SAP Best Practices match your current filters. Try adjusting your search criteria or clearing filters.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
      {practices?.map((practice) => (
        <PracticeCard
          key={practice?.id}
          practice={practice}
          isSelected={selectedPractices?.some(p => p?.id === practice?.id)}
          onSelect={onSelectPractice}
          onViewDetails={onViewDetails}
        />
      ))}
    </div>
  );
};

export default PracticeGrid;